{
  "success": true,
  "id": "club-user-created",
  "name": "Nuevo Club",
  "message": "Club creado correctamente en la competición"
}
